export default __webpack_public_path__ + "static/media/sign-in-card.35228f43.png";